var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home-card",style:(_setup.style)},[_vm._t("header",function(){return [_c('div',{staticClass:"home-card-header"},[_c('div',{staticClass:"header_title"},[_vm._v(_vm._s(_vm.title))])])]}),_c('div',{staticClass:"content"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }